import actions from './constants';

export const fetchRoleActions = (code, category, showDialog) => ({
  type: actions.FETCH_ROLE_ACTIONS,
  code,
  category,
  showDialog,
});

export const fetchRoleActionsSuccess = (code, category, result) => ({
  type: actions.FETCH_ROLE_ACTIONS_SUCCESS,
  code,
  category,
  result,
});

export const fetchRoleActionsError = (code, category, error) => ({
  type: actions.FETCH_ROLE_ACTIONS_ERROR,
  code,
  category,
  error,
});

export const refreshRoleActions = (code) => ({
  type: actions.REFRESH_ROLE_ACTIONS,
  code,
});

export const showRoleActions = (code, category, roleActions, readStatus) => ({
  type: actions.SHOW_ROLE_ACTIONS,
  code,
  category,
  roleActions,
  readStatus,
});

export const hideRoleActions = () => ({
  type: actions.HIDE_ROLE_ACTIONS,
});

export const editRoleActionsProperty = (code, category, roleActions) => ({
  type: actions.EDIT_ROLE_ACTIONS_PROPERTY,
  code,
  category,
  roleActions,
});

export const updateRoleActions = (code, category) => ({
  type: actions.UPDATE_ROLE_ACTIONS,
  code,
  category,
});

export const updateRoleActionsSuccess = (code, category, result, role) => ({
  type: actions.UPDATE_ROLE_ACTIONS_SUCCESS,
  code,
  category,
  result,
  role,
});

export const updateRoleActionsError = (code, category, error) => ({
  type: actions.UPDATE_ROLE_ACTIONS_ERROR,
  code,
  category,
  error,
});
